<template>
  <span>
    <o-select
      v-if="current_template == null"
      :value="value"
      :items="activeFormTemplateVersionItems"
      text-field="form_template_name"
      value-field="id"
      :form-state="formState"
      :loading="optionFormTemplateVersionWorking"
      name="form_template_version"
      :validators="validators"
      :server-errors="_se"
      @input="on_input"
    ></o-select>
    <h1 v-if="current_template != null">
      {{ current_template.form_template_name }}
    </h1>
  </span>
</template>
<script>
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
} from "../../../vue-ocom/mixins";
import { mapActions } from "vuex";
import {
  filter_active_list,
  is_item_active_now,
} from "../../../vue-ocom/utils/active";

export default {
  mixins: [
    CreateFormStateMixin("validators"),
    CreateCodeTableFetchMixin(["FormTemplateVersion", "FormTemplate"]),
  ],
  model: {
    prop: "value",
    event: "input",
  },
  data() {
    return {
      current_template: null,
    };
  },
  props: {
    template_id: { type: Number, default: null },
    value: { type: [Number, String], default: null },
    validators: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    OnBeforeGetFormTemplateCodeList(list_options) {
      list_options.filter = "for_permissions";
    },
    load_template_data(template_version_id) {
      var vm = this;

      // If we have a specific template_version_id, fetch it directly without permissions filter
      // (user might be viewing an existing form created with a template they can't create with anymore)
      if (template_version_id) {
        this.getFormTemplateVersionById(template_version_id)
          .then(function (template) {
            vm.current_template = template;
            vm.$emit("templateVersion", vm.current_template);
          })
          .catch(function (error) {
            console.error("Error loading template version:", error);
            vm.$emit("templateVersion", null);
          });
        return;
      }

      // When selecting a template (no specific ID), use permissions filter
      this.getAllFormTemplateVersion({
        limit: 10000,
        filter: "for_permissions",
      }).then(function (result) {
        if (result.items.length == 1) {
          // Auto SELECT first item as we have no other options
          vm.on_input(result.items[0].id);
        }

        // vm.$emit("templateVersion", null);

        if ("form_template_id" in vm.$route.query) {
          var form_template_id = parseInt(vm.$route.query.form_template_id);

          // Get Current Form Template Version for the specified FormTemplate!
          var active_template_versions = filter_active_list(result.items);
          vm.current_template = _.find(active_template_versions, {
            form_template_id: form_template_id,
          });

          if (vm.current_template) {
            vm.$emit("input", vm.current_template.id);

            vm.$emit("templateVersion", vm.current_template);
          }
        }
      });
    },
    on_input(event) {
      this.load_template_data(event);
      this.$emit("input", event);
    },
    ...mapActions("", { getTemplateVersionByID: "getById" }),
    ...mapActions("FormTemplateModule", { getTemplateByID: "getById" }),
  },
  watch: {
    template_id(newValue) {},
    value(newValue, oldValue) {
      if (newValue != oldValue) {
        this.load_template_data(newValue);
      }
    },
  },
  computed: {
    activeFormTemplateVersionItems() {
      var result = [];
      var form_template = null;

      this.optionFormTemplateVersionItems.forEach((item) => {
        if (item.form_template_id) {
          form_template =
            this.optionFormTemplateItemsById[item.form_template_id];

          if (form_template) {
            if (is_item_active_now(form_template) && is_item_active_now(item)) {
              // use the FormTemplateVersion.ID as the ID of the entry here as we want to store that.
              result.push({ ...item, id: item.id });
            }
          }
        }
      });

      return result;
    },
  },
  created() {
    this.load_template_data(this.value);
  },
};
</script>
